<template>
    <v-container>
        <v-card class="rounded-0 ma-8" flat>
            <v-row class="d-flex flex-row justify-center align-center">
                <v-col cols="12" md="12" class="d-flex justify-center">
                    <v-card-title class="font-weight-bold text-h5 primary--text">
                        {{ titulo }}
                    </v-card-title>
                </v-col>
            </v-row>
            <v-card-text>
                <v-row class="d-flex flex-row justify-center align-center">
                    <v-col cols="6" md="12" class="d-flex justify-center pa-5">
                        <v-icon :color="color" size="100">{{ icon }}</v-icon>
                    </v-col>
                    <v-col cols="6" md="12" class="d-flex justify-center pa-1">
                        <div class="text-body-1 black--text">
                            {{ body }}
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider></v-divider>
        </v-card>
    </v-container>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
    },
    mounted() {
        //**
        // IMPORTANTE:
        //La llamadas a la API consultarOrdenActiva se hace en router/index.js 
        //*/

        //cargo el objeto solo para mostrar mensajes en la vista
        const urlParams = new URLSearchParams(window.location.search)
        this.objBase.type = urlParams.get('type')
        this.objBase.external_reference = urlParams.get('ref')
        this.objBase.nroafi = urlParams.get('nroafi')
    },
    data() {
        return {
            objBase: {
                type: '',
                external_reference: '',
                nroafi: '',
            },
        }
    },
    computed: {
        icon() {
            const iconMap = {
                'succes': 'mdi-check-circle-outline',
                'failure': 'mdi-close-circle-outline',
                'pending': 'mdi-alert-outline',
            }
            for (const key in iconMap) {
                if (this.objBase.type.includes(key)) {
                    return iconMap[key]
                }
            }
        },
        titulo() {
            const titleMap = {
                'success': 'Pago aceptado con éxito',
                'failure': 'Pago no realizado',
                'pending': 'Pago pendiente',
            }
            for (const key in titleMap) {
                if (this.objBase.type.includes(key)) {
                    return titleMap[key]
                }
            }
        },
        color() {
            const colorMap = {
                'success': 'success',
                'failure': 'red',
                'pending': 'orange darken-1',
            }
            for (const key in colorMap) {
                if (this.objBase.type.includes(key)) {
                    return colorMap[key]
                }
            }
        },
        body() {
            const bodyMap = {
                'success': "Su pago ha sido aceptado. Es posible que aún no se refleje en \"Mis aportes\".",
                'failure': 'Por favor, intente nuevamente.',
                'pending': 'Su pago se encuentra pendiente.',
            }
            for (const key in bodyMap) {
                if (this.objBase.type.includes(key)) {
                    return bodyMap[key]
                }
            }
        }
    },
    components: {

    },
    methods: {
        ...mapActions('boletas', ['actualizarOrdenPago']),




    }

}

</script>